import { Link } from 'react-router-dom';
import { allCategories } from '@/utils/news';

const accents = [
  { bg: 'bg-primary-100', text: 'text-primary-700', ring: 'hover:border-primary-300' },
  { bg: 'bg-accent-100', text: 'text-accent-700', ring: 'hover:border-accent-300' },
  { bg: 'bg-secondary-100', text: 'text-secondary-700', ring: 'hover:border-secondary-300' },
];

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
      {allCategories.map((cat, i) => {
        const a = accents[i % accents.length];
        return (
          <Link
            key={cat.key}
            to={`/category/${cat.key}`}
            className={`group flex items-center gap-4 p-4 md:p-5 rounded-lg bg-background-50 border border-background-200 ${a.ring} transition-colors cursor-pointer`}
          >
            <span className={`w-14 h-14 md:w-16 md:h-16 rounded-lg ${a.bg} ${a.text} flex items-center justify-center shrink-0`}>
              <i className={`${cat.icon} text-2xl md:text-3xl`} />
            </span>
            <div className="min-w-0">
              <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950 group-hover:text-primary-600 transition-colors">
                {cat.name}频道
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 mt-1 line-clamp-1">{cat.description}</p>
            </div>
            <i className="ri-arrow-right-line ml-auto text-foreground-400 group-hover:text-primary-600 group-hover:translate-x-0.5 transition-all" />
          </Link>
        );
      })}
    </div>
  );
}